import React from "react";
import Banner from "../components/home/Banner";
import style from "../styles/homepage.module.scss";
import Topics from "../components/home/TopicsList";

const Homepage = () => {
  return (
    <div className={style.wrapper}>
      <Banner style={style} />
      <Topics style={style} />
    </div>
  );
};

export default Homepage;
